<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="px-5">
          <v-col cols="12" md="12" class="pa-0">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center py-0">
                      <v-col cols="12" :class="`${arabic?'arFont':'enFont'} font-weight-bold pb-0`">
                        معلومات الكورس الحالي
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-row class="align-center  pb-0">
                          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'}`">
                            المستوى: 
                            <v-chip label dark x-small color="primary" :class="`${arabic?'arFont':'enFont'}`" v-if="resource.course && resource.course.level_name">{{resource.course.level_name.ar}}</v-chip>
                          </v-col>
                          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'}`">
                            ايام الدراسة: 
                            <v-chip label dark x-small color="primary" :class="`${arabic?'arFont':'enFont'}`" v-if="resource.course">{{resource.course.daysar.join(' | ')}}</v-chip>
                          </v-col>
                          <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'}`">
                            الوقت: 
                            <v-chip label dark x-small color="primary" :class="`${arabic?'arFont':'enFont'}`" v-if="resource.course">{{resource.course.time}}</v-chip>
                          </v-col>
                          <v-col cols="6" md="4" :class="`${arabic?'arFont':'enFont'}`">
                            المدرس: 
                            <v-chip label dark x-small color="primary" :class="`${arabic?'arFont':'enFont'}`" v-if="resource.course && resource.course.teacher_name">{{resource.course.teacher_name.name}}</v-chip>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="8" class="pa-0">
        <v-row class="px-5">
          <v-col cols="12" md="12" class="pa-0">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card :loading="loading">
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12" LOADING :class="`${arabic?'arFont':'enFont'} subheading secondary--text`">
                        <v-row>
                          <v-col cols="12">
                            <v-card :loading="loading">
                              <v-card-text class="py-0">
                                <v-row class="py-0">
                                  <v-col cols="8" :class="`${arabic?'arFont':'enFont'}`" v-if="resource.topic">
                                    <div style="font-size:10px;font-weight:bold;">الموضوع</div>
                                    <div :class="`${arabic_input(resource.topic.title) ? 'arFont' : 'enFont text-left'}`" :style="`${!arabic_input(resource.topic.title) ? 'direction:ltr !important' : ''}`">{{resource.topic.title}}</div>
                                    <div :class="`${arabic_input(resource.topic.text) ? 'arFont' : 'enFont text-left'}`" :style="`${!arabic_input(resource.topic.text) ? 'direction:ltr !important' : ''}`">{{resource.topic.text}}</div>
                                  </v-col>
                                  <v-col cols="4" :class="`${arabic?'arFont':'enFont'}`">
                                    <div style="font-size:10px;font-weight:bold;">موضوع بواسطة</div>
                                    <div v-if="resource.topic && resource.topic.user_name">
                                      <div>
                                        {{resource.topic.user_name.name}}
                                      </div> 
                                      <v-chip x-small label color="secondary">{{getFormat(resource.topic.created_at)}}</v-chip>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12" class="pa-0">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card :loading="loading">
                  
                  <v-card-actions>
                    <Paging 
                      :resourceSettings="resourceSettings" 
                      :resource="resource"
                      @loadResource="loadResource"
                      @pageByNumber="pageByNumber"
                    />
                    <v-spacer></v-spacer>
                    <v-btn color="primary" x-small text :class="`${arabic?'arFont':'enFont'}`" @click="()=>{dialog=true;}">
                      رد جديد 
                    </v-btn>
                  </v-card-actions>
                  <v-card-text class="py-0">
                    <v-row class="align-center">
                      <v-col cols="12" LOADING :class="`${arabic?'arFont':'enFont'} subheading secondary--text`">
                        <listPost 
                          :resource="resource"
                          :resourceSettings="resourceSettings"
                          :loading="loading"
                          :resourceKeys="resourceKeys"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <Paging 
                      :resourceSettings="resourceSettings" 
                      :resource="resource"
                      @loadResource="loadResource"
                      @pageByNumber="pageByNumber"
                    />
                    <v-spacer></v-spacer>
                    <v-btn color="primary" x-small text :class="`${arabic?'arFont':'enFont'}`" @click="()=>{dialog=true;}">
                      رد جديد 
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <newPostToTopic
            :loading="loading"
            :dialog="dialog"
            @closeDialog="()=>{dialog=false}"
            @postResource="postResource"
          />
        </v-row>
      </v-col>
      <v-col cols="12" md="4" class="pa-0">
        <v-row class="px-5">
          <v-col cols="12" md="12" class="pa-0">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-title :class="`${arabic?'arFont':'enFont'}`">
                    صفحات هامة
                  </v-card-title>
                  <v-card-text class="py-0">
                    <v-list dense nav v-for="(item, i) in course_items" :key="'item-' + i" class="specialMenu py-0">
                      <v-list-item v-if="!item.subs" @click="goTo(`${item.path}/${resource.course.hash}`)">
                        <v-list-item-icon>
                          <v-icon>{{item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title :class="`${arabic?'arFont':'enFont'}`">{{i18n[item.text]}}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import Paging from '@/components/Paging'
import newPostToTopic from '@/components/newPostToTopic'
import listPost from '@/components/listPost'
import { format } from 'timeago.js';

export default {
  components: {Paging, newPostToTopic, listPost},
  data() {
    return {
      loading:false,
      dialog:false,
      course_items:[
        {icon:'space_dashboard', text:'courseTeacher', path:'/admin-course'},
        {icon:'space_dashboard', text:'forumTeacher', path:'/admin-forum'},
        // {icon:'space_dashboard', text:'examTeacher', path:'/admin-exam'},
        {icon:'space_dashboard', text:'assignmentsTeacher', path:'/admin-assignments'},
      ],
      resourceKeys:[
        
      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:false,
        pagination:true,
      },
      resource:{},
      newResource:{},
    }
  },
  methods: {
    arabic_input(string){
      var arabic = /[\u0600-\u06FF]/;
      return arabic.test(string)
    },
    getFormat(d){
      return format(d)
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let hash = this.$route.params.hash
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/get-current-topic/' + hash, page:`?page=${n}` + this.buildFilter()})
          this.accounts = this.resource.accounts
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/get-current-topic/' + hash + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    buildFilter(){
      let filter = ``
      
      return filter
    },
    async filterUsers(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user) {
      }
    },
    async loadResource(h) {
      return new Promise(async (res, rej)=>{
        this.loading = true
        let hash = this.$route.params.hash
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/get-current-topic/' + hash + '?' + this.buildFilter()})
          console.log(this.resource)
          this.accounts = this.resource.accounts
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/get-current-topic/' + hash + '/search', value:this.search})
        }
        this.loading = false
        res()
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        // console.log(r)
        await this.$store.dispatch('putResource', {resource:'/get-current-topic' + `/${r.id}`, value:r})
        this.loadResource()
        this.loading = false
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let hash = this.$route.params.hash
        await this.$store.dispatch('postResource', {resource:'/new-post/' + hash + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async init(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let hash = this.$route.params.hash
        await this.loadResource(hash)
        this.loading = false
        res(true)
      })
    }
    
  },
  computed:{
    progress(){
      return (this.visible + this.prev_progress)/69 * 100
    },
    questions(){
      return this.quiz
    },
    cc(){
      return this.$store.state.cc
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      const items = [...this.$store.state.modelMenu]
      let user = {...this.$store.state.user}
      let role = user.role
      this.$store.menu = items.map(x=>{
        if(x.subs) {
          return {
            ...x, 
            subs:x.subs.filter(x=>x&&x.roles.includes(role))
          }
        } else if(x&&x.roles.includes(role)) {
          return {
            ...x
          }
        }
      }).filter(x=>x&&x.roles.includes(role))
      return this.$store.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications
    },
    // countries(){
    //   return this.$store.state.countries
    // },
    country(){
      return this.$store.state.country
    },
  },
  watch:{
    
  },
  async created(){
    await this.init()
  },
}
</script>

<style>
.flagBtn {
  height: 80px !important;
}
</style>